module.exports = __webpack_public_path__ + "img/live1.c9b1ce84.png";